import React from 'react';
import AppContext from './AppContext';

interface WithAppContextProps {
  images: { [key: string]: string };
  svgInline: { [key: string]: React.FC };
  lotties: { [key: string]: any };
  navigation: { [key: string]: { path?: string; translationKey: string; externalPath?: string }[] };
  consts: {
    [key: string]:
      | string
      | number
      | string[]
      | number[]
      | { [key: string]: string | string[] | number[] };
  };
  post: (data: any) => void;
}

export default function withAppContext<T extends WithAppContextProps = WithAppContextProps>(
  WrappedComponent: React.ComponentType<T>
) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  const ComponentWithAppContext = (props: Omit<T, keyof WithAppContextProps>) => {
    return (
      <AppContext.Consumer>
        {(contexts) => <WrappedComponent {...contexts} {...(props as T)} />}
      </AppContext.Consumer>
    );
  };

  ComponentWithAppContext.displayName = `withAppContext(${displayName})`;

  return ComponentWithAppContext;
}
